// lineChart.

import ReactECharts from "echarts-for-react";
import type { EChartsOption } from "echarts";
import { ChartShell } from "./_chartShell";
import type { VisualProps } from "./types";
import {
  baseChartOption,
  bucketKey,
  bucketKeys,
  firstFieldRef,
  isEmpty,
  makeCategoryClick,
  pbiAxisDefault, // AGENT-C: dotted gridlines + Segoe UI axis labels.
  pickColumn,
} from "./_echartsHelpers";

export function LineChartVisual({ spec, data, onFilter }: VisualProps) {
  const empty = isEmpty(data);
  const rows = data.rows ?? [];
  const fields = spec.fields ?? {};
  const categoryKey = bucketKey(fields.Category);
  const yKeys = bucketKeys(fields.Y).length
    ? bucketKeys(fields.Y)
    : bucketKeys(fields.Values);
  const onClick = makeCategoryClick(
    { visualId: spec.id, spec, onFilter },
    firstFieldRef(fields.Category),
  );

  const option: EChartsOption = {
    ...baseChartOption(),
    // AGENT-C: PBI-style axes (dotted gridlines, 11px muted labels).
    xAxis: {
      ...pbiAxisDefault,
      type: "category",
      boundaryGap: false,
      data: categoryKey ? (pickColumn(rows, categoryKey) as string[]) : [],
    },
    yAxis: { ...pbiAxisDefault, type: "value" },
    series: yKeys.map((k) => ({
      type: "line",
      name: k,
      smooth: false,
      showSymbol: false,
      data: pickColumn(rows, k) as number[],
    })),
  };

  return (
    <ChartShell title={spec.title} isEmpty={empty} status={data.status}>
      <ReactECharts
        option={option}
        notMerge
        style={{ height: "100%", width: "100%" }}
        onEvents={{ click: onClick }}
      />
    </ChartShell>
  );
}
